import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { Router, RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { GuardsModule } from '@bling-fe/shared/core/shared/guards/guards.module';
import { TokenInterceptor } from '@bling-fe/shared/core/shared/token.interceptor';
import {
  AddAppVersionToHeadersInterceptor,
  APP_VERSION
} from '@bling-fe/shared/core/shared/add-app-version-to-headers.interceptor';
import { ServicesModule } from '@bling-fe/shared/core/shared/services/services.module';
import { CoreModule } from '@bling-fe/shared/core/core/core.module';
import { SharedModule } from '@bling-fe/shared/core/shared/shared.module';
import { FlinkIconsModule } from '@bling-fe/shared/icons/flink-icons.module';
import { TraceService } from '@sentry/angular';
import { APP_TENANT_CONFIG } from '@bling-fe/shared/tenant-config';
import { provideLinkHandling } from '@bling-fe/shared/core/shared/services/link-handling.providers';
import { provideEditorContentLinkSearch } from '@bling-fe/shared/core/shared/services/editor-content-link-search.provider';
import { FLINK_TENANTS } from '../tenant-config';
// eslint-disable-next-line @nx/enforce-module-boundaries
import packageJson from '../../../../package.json';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot({
      mode: 'ios',
      swipeBackEnabled: false
    }),
    AppRoutingModule,
    GuardsModule,
    ServicesModule,
    CoreModule,
    SharedModule,
    FlinkIconsModule,
    IonicModule
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: APP_VERSION, useValue: packageJson.version },
    { provide: APP_TENANT_CONFIG, useValue: FLINK_TENANTS },
    provideLinkHandling(),
    provideEditorContentLinkSearch(),
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AddAppVersionToHeadersInterceptor,
      multi: true
    },
    {
      provide: TraceService,
      deps: [Router]
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [TraceService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
